import { createReducer, on } from "@ngrx/store";
import { friendCreate, friendDelete, friendList, friendUpdate } from "./friend.action";

export const INIT_STATE = {
  items: [],
};

export const reducerFriend = createReducer(
  INIT_STATE,
  on(friendList, (state, { items }) => {
    return {
      ...state,
      items: [...items],
    };
  }),
  on(friendCreate, (state, { item }) => {
    return {
      ...state,
      items: [item, ...state.items],
    };
  }),
  on(friendUpdate, (state, { item }) => {
    let index = state.items.findIndex((o) => o.id === item.id);

    const items = [...state.items];

    if (index > -1) {
      items[index] = item;
    }

    return {
      ...state,
      items: items,
    };
  }),
  on(friendDelete, (state, { item }) => {
    let items = state.items.filter((o) => o.id !== item.id);

    return {
      ...state,
      items: items,
    };
  })
);
